import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTela, setFiltro, initForm, salvarEntrada, salvar, excluir, getListaExecucao as getLista,
	getListaMotorista, getListaPlaca, salvarExecucao, salvarItemManutencao
} from './controlePatioActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';
import ConfirmModal from '../common/modal/confirmModal';

const columns = [{
    field: 'id_controle_patio',
    type: 'integer'
}, {
    field: 'nome_registro',
    type: 'text'
}, {
    field: 'nome_tipo_registro',
    type: 'text'
}, {
    field: 'nome_setor',
    type: 'text'
}, {
    field: 'datahora_inicio',
    type: 'text'
}, {
    field: 'datahora_fim',
    type: 'text'
}];

class ControlePatioExecucao extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'id_controle_patio',
			direction: 'asc'
		},
		itensAbertos: [],
		pendenciasAbertas: []
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaSetor();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
    }

	componentWillUnmount() {
		clearInterval(this.idIntervalAtualizacao);
	}
	
    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'executar' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisarExecucao || '').trim()
				|| (this.props.filtro.pesquisarExecucao.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.id_controle_patio}
						${item.nome_setor}
						${item.nome_tipo_registro}: ${item.nome_registro}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}
						${item.shipping_saida}
						${item.rumo_saida}
						${item.cliente_saida}
						${item.rumo_saida == 'RS' ? item.fronteira_saida : item.destino_saida}
						${item.lote_crt_saida ? 'Lote' : ''}
						${item.carga_classificada_saida ? 'Classificada' : ''}
						${item.expresso_saida ? 'Expressa' : ''}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return listaFiltrada;
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar().filter(item => {
			const setor = this.props.listaSetor.filter(itemSetor => itemSetor.id == item.id_setor)[0];

			return setor && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(setor.permissao);

		});

		const heightTela = window.innerWidth < 768 ? `${window.innerHeight - 180}px` : window.innerWidth < 768 ? `${window.innerHeight - 180}px` : (
			window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
				: (
					window.innerWidth < 1799
						? `${window.innerHeight - 180}px`
						: (
							window.innerWidth < 4000
								? `${window.innerHeight - 180}px`
								: `${window.innerHeight - 180}px`
						)
				)
		);

		const pendentes = lista.filter(item => !item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao && item.liberado_execucao).length;
		const executando = lista.filter(item => item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao && item.liberado_execucao).length;
		const aguardandoChegada = lista.filter(item => !item.datahora_fim && !item.datahora_liberacao && !item.liberado_execucao && item.nao_passou_patio).length;
		const finalizado = lista.filter(item => item.datahora_fim || item.datahora_liberacao).length;
		const total = lista.filter(item => item.nao_passou_patio).length;

		//Filtrar Status
		lista = lista.filter(item => {

			//Se já passou pelo pátio ignora
			if (!item.nao_passou_patio) {
				return false;
			}

			if (!this.props.filtro.pendenteExecucao &&
				(!item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao && item.liberado_execucao)) {
				return false;
			}

			if (!this.props.filtro.executando &&
				(item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao && item.liberado_execucao)) {
				return false;
			}

			if (!this.props.filtro.aguardandoChegadaExecucao &&
				(!item.datahora_fim && !item.datahora_liberacao && !item.liberado_execucao)) {
				return false;
			}

			if (!this.props.filtro.finalizadoExecucao &&
				(item.datahora_fim || item.datahora_liberacao)) {
				return false;
			}

			return true;
		});

		return (
			<ContentCard>

				{this.state.confirmacao &&
				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem={this.state.confirmacao.mensagem}
					textoConfirmar='Sim'
					textoCancelar='Cancelar'
					onConfirm={this.state.confirmacao.eventoSim}
					onCancel={this.state.confirmacao.eventoCancelar}
				/>}

				<ContentCardBody>
					<Row alignCenter style={{ marginTop: 2, marginBottom: 8, marginLeft: 0 }}>

						<InputPesquisa
							marginRight={8}
							marginBottom={0}
							maxWidth={400}
							cols='12 12 12 12'
							label={null}
							value={this.props.filtro.pesquisarExecucao}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisarExecucao: value })} />

						<div style={{ marginTop: 5, textAlign: 'center' }}>
							<div class={`filter-chip ${this.props.filtro.pendenteExecucao ? 'active' : ''}`}
								style={{ width: 95, height: 20, fontSize: 10, marginBottom: 1, marginTop: 4, marginLeft: 0, marginRight: 2 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										pendenteExecucao: !this.props.filtro.pendenteExecucao
									});
								}}>
								<b>{pendentes}</b> Pendentes
							</div>
							<div class={`filter-chip ${this.props.filtro.executando ? 'active' : ''}`}
								style={{ width: 95, height: 20, fontSize: 10, marginBottom: 1, marginTop: 4, marginLeft: 0, marginRight: 2 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										executando: !this.props.filtro.executando
									});
								}}>
								<b>{executando}</b> Executando
							</div>
							<div class={`filter-chip ${this.props.filtro.aguardandoChegadaExecucao ? 'active' : ''}`}
								style={{ width: 100, height: 20, fontSize: 10, marginBottom: 1, marginTop: 4, marginLeft: 0, marginRight: 2 }}
								title='Ainda não chegaram no pátio mas saem até das 08:00'
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										aguardandoChegadaExecucao: !this.props.filtro.aguardandoChegadaExecucao
									});
								}}>
								<b>{aguardandoChegada}</b> S/ Entrada
							</div>
							<div class={`filter-chip ${this.props.filtro.finalizadoExecucao ? 'active' : ''}`}
								style={{ width: 95, height: 20, fontSize: 10, marginBottom: 1, marginTop: 4, marginLeft: 0, marginRight: 2 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										finalizadoExecucao: !this.props.filtro.finalizadoExecucao
									});
								}}>
								<b>{finalizado}</b> Finalizados
							</div>
							<div class={`filter-chip ${this.props.filtro.pendenteExecucao && this.props.filtro.aguardandoChegadaExecucao && this.props.filtro.finalizadoExecucao ? 'active' : ''}`}
								style={{ width: 75, height: 20, fontSize: 10, marginBottom: 1, marginTop: 4, marginLeft: 0, marginRight: 2 }}
								onClick={() => {

									const status = this.props.filtro.pendenteExecucao && this.props.filtro.aguardandoChegadaExecucao && this.props.filtro.finalizadoExecucao;

									this.props.setFiltro({
										...this.props.filtro,
										pendenteExecucao: !status,
										executando: !status,
										aguardandoChegadaExecucao: !status,
										finalizadoExecucao: !status
									});
								}}>
								<b>{total}</b> Total
							</div>
						</div>
					</Row>
					
					<div style={{ display: 'flex', flexDirection: 'column', gap: 12, height: heightTela, overflowY: 'auto' }}>
						{lista.map((item, i) => {
							
							const selecionado = this.state.linhaSelecionada == item.id
							
							const setor = this.props.listaSetor.filter(itemSetor => itemSetor.id == item.id_setor)[0];

							const usuarioGestor = ['GESTOR'].includes(setor.permissao);
							const usuarioSupervisor = ['SUPERVISOR'].includes(setor.permissao);

							return (
								<div
									key={item.id}
									style={{
										border: '1px solid #dcdcdc',
										borderRadius: 8,
										padding: 12,
										backgroundColor: item.liberado_execucao ? '#ffffff' : '#fff8f0',
										boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
										cursor: 'pointer'
									}} >
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
										<div style={{ fontSize: 18, fontWeight: 'bold' }}>{item.nome_registro} {!item.liberado_execucao ? ' - Não Chegou' : ''}</div>
										<div style={{
											backgroundColor: '#ffffff',
											color: '#1F3066',
											border: '1px solid #A5ADD1',
											fontSize: 12,
											fontWeight: '400',
											paddingTop: 2, 
											paddingTop: 2, 
											paddingLeft: 8, 
											paddingRight: 8,
											height: 24, 
											borderRadius: 4 
										}}>{item.nome_setor}</div>
									</div>
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										<div style={{ fontSize: 12, fontWeight: 'normal' }}>{item.nome_tipo_registro}</div>
										<div style={{ fontSize: 12, fontWeight: 'normal' }}>{[item.cavalo_controle, item.carreta1_controle, item.carreta2_controle].filter(placa => placa && placa != item.nome_registro).join(' | ')}</div>
										<div style={{ fontSize: 12, fontWeight: 'normal' }}>ID: {item.id_controle_patio}</div>
									</div>

									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', fontSize: 12 }}>
										<div>{item.nome_motorista_controle}</div>
									</div>
									
									<div style={{ display: 'flex', alignItems: 'center', width: '100%', color: item.atraso == 'atrasado' ? '#b80300' : '' }}>
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1, fontSize: 16 }}><b>Prev. Saída: {DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</b></div>
									</div>

									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', fontSize: 12 }}>
										<div><strong>Rumo:</strong> {item.rumo_saida}</div>
										{item.cliente_saida && 
										<div><strong>Cliente:</strong> {item.cliente_saida}</div>}
									</div>

									<div style={{ display: 'flex', alignItems: 'center', width: '100%', fontSize: 12 }}>
										{item.rumo_saida == 'RS' &&
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Fronteira:</b> {item.fronteira_saida}</div>}
										{item.rumo_saida != 'RS' &&
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Destino:</b> {item.destino_saida}</div>}
									</div>
									<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
										{item.lote_crt_saida &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2
												}}
												title={item.lote_crt_entrada}>
												<i class='fas fa-boxes' style={{ marginRight: 4 }}></i>
												Lote
											</div>}
										{item.carga_classificada_saida &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2
												}}>
												<i class='fas fa-exclamation-triangle' style={{ marginRight: 4 }}></i>
												Classificada
											</div>}
										{item.expresso_saida &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2
												}}>
												<i class='fas fa-shipping-fast' style={{ marginRight: 4 }}></i>
												Expressa
											</div>}
									</div>

									{/* Itens */}
									{(item.lista_manutencao || []).length > 0 && (
										<div>
											<div
												onClick={() => {
													
													let listaAux = this.state.itensAbertos.map(itemAux => itemAux);
													if (listaAux.includes(item.id)) {
														listaAux = listaAux.filter(itemAux => itemAux != item.id);
													} else {
														listaAux.push(item.id);
													}
													this.setState({
														 itensAbertos: listaAux
													});
													
												}}
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													cursor: 'pointer',
													background: '#f5f5f5',
													padding: '6px 10px',
													borderRadius: 4,
													marginBottom: 0,
													marginTop: 4
												}}
											>
												<strong>Itens ({item.lista_manutencao.length})</strong>
												<span>
													{this.state.itensAbertos.includes(item.id) ? '▲' : '▼'}
												</span>
											</div>

											{this.state.itensAbertos.includes(item.id) && (
												<div
													style={{
														padding: '8px 12px',
														border: '3px solid #f5f5f5',
														marginTop: 0
													}} >
													<div
														style={{
															display: 'flex',
															flexWrap: 'wrap',
															gap: 6
														}} >
														{item.lista_manutencao.map((manutencao, pos) => (
															<div key={pos} style={{ fontSize: 13, display: 'flex', alignItems: 'center', width: '100%' }}>
																<label
																	style={{
																		fontSize: 14,
																		display: 'flex',
																		alignItems: 'center',
																		padding: '6px 4px',
																		cursor: 'pointer',
																		userSelect: 'none'
																	}}
																>
																	<input
																		type='checkbox'
																		checked={!!manutencao.executado}
																		onChange={() => {
																			if (item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao) {
																				this.props.salvarItemManutencao({
																					...manutencao,
																					executado: !manutencao.executado
																				});
																			} else {
																				window.alert(item.datahora_inicio ? 'Serviço finalizado' : 'Serviço ainda não foi iniciado');
																			}
																		}}
																		style={{
																			marginRight: 10,
																			width: 18,
																			height: 18,
																			cursor: 'pointer'
																		}}
																	/>

																	<span
																		style={{
																			textDecoration: manutencao.executado ? 'line-through' : 'none',
																			color: manutencao.executado ? '#888' : '#000',
																			fontSize: 12,
																			fontWeight: 'normal'
																		}}
																	>
																		{manutencao.descricao}
																	</span>
																</label>
															</div>
														))}
													</div>
												</div>
											)}
										</div>
									)}

									{/* Pendências */}
									{(item.pendencias_abertas || []).length > 0 && (
										<div>
											<div
												onClick={() => {
													
													let listaAux = this.state.pendenciasAbertas.map(itemAux => itemAux);
													if (listaAux.includes(item.id)) {
														listaAux = listaAux.filter(itemAux => itemAux != item.id);
													} else {
														listaAux.push(item.id);
													}
													this.setState({
														 pendenciasAbertas: listaAux
													});
													
												}}
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													cursor: 'pointer',
													background: '#f5f5f5',
													padding: '6px 10px',
													borderRadius: 4,
													marginBottom: 0,
													marginTop: 4
												}}
											>
												<strong>Pendências ({item.pendencias_abertas.length})</strong>
												<span>
													{this.state.pendenciasAbertas.includes(item.id) ? '▲' : '▼'}
												</span>
											</div>

											{this.state.pendenciasAbertas.includes(item.id) && (
												<div
													style={{
														padding: '8px 12px',
														border: '3px solid #f5f5f5',
														marginTop: 0
													}} >
													<div
														style={{
															display: 'flex',
															flexWrap: 'wrap',
															gap: 6
														}} >
														{item.pendencias_abertas.map(pendencia => (
															<span
																key={pendencia.id}
																style={{
																	backgroundColor: '#949191',
																	color: '#ffffff',
																	border: '1px solid #949191',
																	borderRadius: 12,
																	padding: '4px 10px',
																	fontSize: 12,
																	fontWeight: 600,
																	display: 'inline-flex',
																	alignItems: 'center'
																}}
															>
																<i
																	className="fas fa-exclamation-circle"
																	style={{
																		marginRight: 5,
																		fontSize: 11
																	}}
																/>
																{pendencia.nome_tipo}
															</span>
														))}
													</div>
												</div>
											)}
										</div>
									)}

									{(item.datahora_inicio || item.datahora_fim || item.datahora_liberacao) &&
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										{item.datahora_inicio &&
										<div><strong>Início:</strong> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}</div>}
										{item.datahora_fim &&
										<div><strong>Fim:</strong> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}</div>}
										{item.datahora_liberacao &&
										<div><strong>Liberado:</strong> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao)}</div>}
									</div>}
								
									{/* Datas e botões */}
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: 10,
											flexWrap: 'wrap',
											gap: 8
										}}>
										{!item.datahora_liberacao &&
										<div>
											{!item.datahora_inicio ? (
												<a className={`btn btn-app ${item.liberado_execucao ? 'bg-success' : 'bg-light'} ${item.liberado_execucao ? '' : 'disabled'}`}
													style={{ marginBottom: 0, marginLeft: 0 }}
													onClick={() => {
														if (item.liberado_execucao) {
															this.props.salvarExecucao({
																...item,
																datahora_inicio: DateFormat.getDataHoraAtual(),
																id_usuario_inicio: this.props.sessao.id
															});
														}
													}}>
													<i className='fas fa-play'></i> Iniciar
												</a>
											) : ((!item.datahora_pausa && !item.datahora_fim) ? (
												<a className='btn btn-app bg-warning'
													style={{ marginBottom: 0, marginLeft: 0 }}
													onClick={() => {
														this.setState({
															confirmacao: {
																mensagem: 'Deseja realmente desfazer início?',
																eventoSim: () => {
																	this.props.salvarExecucao({
																		...item,
																		datahora_inicio: null,
																		id_usuario_inicio: null
																	});
																	this.setState({
																		confirmacao: null
																	});
																},
																eventoCancelar: () => {
																	this.setState({
																		confirmacao: null
																	});
																}
															}
														});
													}}>
													<i className='fas fa-undo'></i> Desfazer
												</a>
											) : null)}
										</div>}

										<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
											{(item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao) &&
											<div>
												{!item.datahora_pausa ? (
													<a className='btn btn-app bg-secondary'
														style={{ marginBottom: 0, marginLeft: 0 }}
														onClick={() => {
															this.props.salvarExecucao({
																...item,
																datahora_pausa: DateFormat.getDataHoraAtual()
															});
														}}>
														<i className='fas fa-pause'></i> Pausar
													</a>
													) : (
														<a className='btn btn-app bg-success'
														style={{ marginBottom: 0, marginLeft: 0 }}
														onClick={() => {
															this.props.salvarExecucao({
																...item,
																datahora_pausa: null
															});
														}}>
														<i className='fas fa-play'></i> Continuar
													</a>
												)}
											</div>}

											{(item.datahora_inicio && !item.datahora_fim && !item.datahora_liberacao && !item.datahora_pausa) &&
											<div>
												<a className='btn btn-app bg-success'
													style={{ marginBottom: 0, marginLeft: 0 }}
													onClick={() => {
														
														const possuiManutencao = !!(item.lista_manutencao || []).length;

														this.setState({
															confirmacao: {
																mensagem: possuiManutencao ? 'Deseja realmente finalizar?' : 'Confirma que os itens selecionados na manutenção foram realizados?',
																eventoSim: () => {
																	this.props.salvarExecucao({
																		...item,
																		datahora_fim: DateFormat.getDataHoraAtual(),
																		id_usuario_fim: this.props.sessao.id
																	});
																	this.setState({
																		confirmacao: null
																	});
																},
																eventoCancelar: () => {
																	this.setState({
																		confirmacao: null
																	});
																}
															}
														});
													}}>
													<i className='fas fa-check'></i> Finalizar
												</a>
											</div>}

											{/* Liberação */}
											<div>
												{(usuarioGestor && !item.datahora_fim && !item.datahora_liberacao) &&
												<a className='btn btn-app bg-primary'
													style={{ marginBottom: 0, marginLeft: 0 }}
													onClick={() => {
														this.setState({
															confirmacao: {
																mensagem: 'Deseja realmente liberar?',
																eventoSim: () => {
																	this.props.salvarExecucao({
																		...item,
																		datahora_liberacao: DateFormat.getDataHoraAtual(),
																		id_usuario_liberacao: this.props.sessao.id,
																		datahora_pausa: null
																	});
																	this.setState({
																		confirmacao: null
																	});
																},
																eventoCancelar: () => {
																	this.setState({
																		confirmacao: null
																	});
																}
															}
														});
													}}>
													<i className='fas fa-user-check'></i> Liberar
												</a>}
											</div>
										</div>

										{/* Reabrir */}
										{((usuarioGestor || usuarioSupervisor) && (item.datahora_fim || item.datahora_liberacao)) &&
										<div>
											<a className='btn btn-app bg-warning'
												style={{ marginBottom: 0, marginLeft: 0 }}
												onClick={() => {
													this.setState({
															confirmacao: {
																mensagem: 'Deseja realmente reabrir?',
																eventoSim: () => {
																	this.props.salvarExecucao({
																		...item,
																		datahora_fim: null,
																		id_usuario_fim: null,
																		datahora_liberacao: null,
																		id_usuario_liberacao: null
																	});
																	this.setState({
																		confirmacao: null
																	});
																},
																eventoCancelar: () => {
																	this.setState({
																		confirmacao: null
																	});
																}
															}
														});
												}}>
												<i className='fas fa-undo'></i> Reabrir
											</a>
										</div>}
									</div>
								</div>
							)
						})}
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTela,
	lista: state.controlePatio.listaExecucao,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvarEntrada, salvar, excluir, getLista,
	getListaMotorista, getListaPlaca, salvarExecucao, salvarItemManutencao, getListaSetor
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioExecucao);
